import { render, staticRenderFns } from "./home_recently_viewed.vue?vue&type=template&id=509328f8&"
import script from "./home_recently_viewed.vue?vue&type=script&lang=js&"
export * from "./home_recently_viewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports